/* Plain-word reasons shown under a message that was not sent or not delivered.
 * Kept in step with backend services/twilio_failure.py. */
const TWILIO_ERROR_TEXT = {
  '21211': 'The phone number is not valid.',
  '21408': 'Sending to this country is not enabled.',
  '21610': 'The customer has unsubscribed (STOP).',
  '21614': 'The number cannot receive SMS.',
  '21656': 'The WhatsApp template variables are not valid.',
  '30003': 'The phone is switched off or unreachable.',
  '30004': 'The customer has blocked messages.',
  '30005': 'The number does not exist.',
  '30006': 'The number is a landline.',
  '30007': 'The carrier filtered the message as spam.',
  '30008': 'The carrier did not deliver the message.',
  '63016': 'Outside the 24-hour WhatsApp window: only an approved template can be sent.',
  '63024': 'The customer is not on WhatsApp.',
  '63027': 'The WhatsApp template could not be sent.',
  '63032': 'The WhatsApp session has expired.',
  '63033': 'There is no active WhatsApp session.',
  '63049': 'Meta did not deliver this marketing template.',
  '63112': 'The WhatsApp Business account is restricted.',
};

const SEND_ERROR_TEXT = {
  whatsapp_service_window_closed: 'Outside the 24-hour WhatsApp window: only an approved template can be sent.',
  whatsapp_freeform_blocked: 'Outside the 24-hour WhatsApp window: only an approved template can be sent.',
  template_approval_unverifiable: 'Twilio template approval could not be checked.',
  template_not_approved: 'The WhatsApp template is not approved.',
  template_language_or_variables: 'The template language or variables do not match this step.',
  approved_content_sid_not_configured: 'No approved WhatsApp template is configured for this step.',
  twilio_not_configured: 'Twilio is not configured.',
  no_customer_number: 'The customer has no WhatsApp or phone number.',
  twilio_rejected: 'Twilio rejected the message.',
  network_error: 'Twilio could not be reached.',
  provider_did_not_return_message_sid: 'Twilio did not confirm the message.',
  no_approved_template_for_step: 'No approved WhatsApp template for this bot step. A person must reply.',
};

export const deliveryFailureText = (metadata) => {
  const meta = metadata || {};
  const code = String(meta.twilio_error_code || '');
  if (TWILIO_ERROR_TEXT[code]) return TWILIO_ERROR_TEXT[code];
  const reason = meta.twilio_send_error || meta.twilio_template_send_error;
  if (SEND_ERROR_TEXT[reason]) return SEND_ERROR_TEXT[reason];
  if (code) return `Twilio error ${code}.`;
  return 'No reason was reported.';
};
